"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.multiply = multiply;
const tslib_1 = require("tslib");
const big_js_1 = tslib_1.__importDefault(require("big.js"));
/**
 * Returns the product of two numbers using Big.js for precise calculations.
 */
function multiply(a, b) {
    return new big_js_1.default(a).times(b).times(1000);
}
